import type { ReactNode } from "react";

interface SectionTitleProps {
  eyebrow?: string;
  title: string;
  desc?: string;
  action?: ReactNode;
}

export default function SectionTitle({ eyebrow, title, desc, action }: SectionTitleProps) {
  return (
    <div className="mb-6 flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
      <div>
        {eyebrow && (
          <span className="mb-2 inline-flex items-center gap-1.5 text-xs font-label font-semibold uppercase tracking-[0.2em] text-primary-400">
            <span className="h-3 w-1 rounded-full bg-primary-500" />
            {eyebrow}
          </span>
        )}
        <h2 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">{title}</h2>
        {desc && <p className="mt-2 max-w-2xl text-sm text-foreground-600">{desc}</p>}
      </div>
      {action && <div className="shrink-0">{action}</div>}
    </div>
  );
}